import React from 'react';
import PropTypes from 'prop-types';
import { getTranslations } from '@translations';
import { isEnabled } from '@utils/featureFlagsABTests';
import {
  Button,
  Icon,
  Dropdown,
  DropdownTrigger,
  DropdownLayover,
  Hr,
} from '@components';
import { menuAccountItems } from './constants';
import { Login } from './components';
import { useHeaderContext } from '../../../../HeaderContext';

import styles from './styles/index.module.scss';

const Account = ({ isB2B, isAuthenticated, className }) => {
  const translations = getTranslations();
  const { platformBaseUrl, featureFlags, abTests } = useHeaderContext();
  const ffProServicesInvoices = isEnabled(
    featureFlags,
    'ff-pro-services-invoices',
  );
  const items = menuAccountItems(isAuthenticated, isB2B, ffProServicesInvoices);
  const isMyAccountEnabled =
    isEnabled(featureFlags, 'ff-after-buy-account-area') &&
    isEnabled(abTests, 'after-buy-account-area');
  const url = translations(
    `header.menu.account.${isMyAccountEnabled ? 'account_area' : 'url'}`,
  );

  return (
    <div className={className}>
      <Dropdown>
        <DropdownTrigger>
          <Button
            color="transparent"
            className={styles.accountTab}
            tag="a"
            href={`${platformBaseUrl}${url}`}
            data-qa="selectUserAccountCta"
          >
            <Icon
              isB2B={isB2B}
              size="24"
              id="account"
              className={styles.accountIcon}
              data-qa="iconUserAccountCta"
            />
            <span className={styles.accountText} data-qa="textUserAccountCta">
              {isB2B
                ? translations('header.subheader.account.b2b')
                : translations('header.menu.account')}
            </span>
          </Button>
        </DropdownTrigger>
        <DropdownLayover>
          <div className={styles.accountMenu} data-qa="accountLayover">
            {!isAuthenticated && !isB2B ? <Login /> : null}
            {items.map(({ id, href, hasSeparator, dataQa }) => (
              <React.Fragment key={id}>
                {hasSeparator ? <Hr /> : null}
                <div className={styles.accountMenuItem} data-qa={dataQa}>
                  <a
                    className={styles.accountMenuLink}
                    href={`${platformBaseUrl}${translations(href)}`}
                  >
                    {translations(id)}
                  </a>
                </div>
              </React.Fragment>
            ))}
          </div>
        </DropdownLayover>
      </Dropdown>
    </div>
  );
};

Account.propTypes = {
  isB2B: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  className: PropTypes.string,
};

Account.defaultProps = {
  isB2B: false,
  isAuthenticated: false,
  className: null,
};

export default Account;
